import isDev from 'Helpers/isDev';

export const assertSafeSpreadAttributes = (props) => {
  Object.keys(props).forEach((key) => {
    if (!key.startsWith('data-') && isDev()) {
      throw new Error(`Invalid spread operator: ${key}`);
    }
  });
};
